var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternal)?_c('a',{attrs:{"href":_vm.formatedUrl,"target":_vm.target}},[_vm._t("default")],2):_c('router-link',_vm._b({},'router-link',_vm.originProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }